<div class="container">
    <lib-no-data
        [iconName]="'forbidden'"
        [title]="'Sorry... the page you’re trying to access has restricted access.'"
        [text]="'Please refer to your system administrator'"
        [linkText]="'Go to Dashboard'"
        (linkAction)="onLinkActionClicked()"
    >
    </lib-no-data>
</div>
